module.exports = __webpack_public_path__ + "img/liangguangmofakoudai.min.b4e16401.png";